import { useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';

/**
 * ScrollToTop Component
 * 
 * Scrolls the main content area to top on route changes.
 * This is necessary because MainLayout uses a scrollable container (<main>)
 * instead of window scroll, so React Router's default scroll restoration doesn't work.
 * 
 * Usage: Place this component inside MainLayout's <main> element
 */
export function ScrollToTop() {
  const { pathname } = useLocation();
  const mainRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    // Find the scrollable main container
    const mainElement = document.querySelector('main');
    
    if (mainElement) {
      // Scroll to top of the main container
      mainElement.scrollTo({
        top: 0,
        behavior: 'instant' // Use 'instant' for immediate scroll, 'smooth' for animated
      });
    }
  }, [pathname]); // Trigger on route change

  return null; // This component doesn't render anything
}
